import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.BudgetCategoryDetailsCard`

export default defineMessages({
  budget: {
    id: `${scope}.budget`,
    defaultMessage: 'Budget',
  },
  currentSpend: {
    id: `${scope}.currentSpend`,
    defaultMessage: 'Current spend',
  },
  pendingRequests: {
    id: `${scope}.pendingRequests`,
    defaultMessage: 'Pending requests',
  },
  categoryBreakdownTableLabel: {
    id: `${scope}.categoryBreakdownTableLabel`,
    defaultMessage: 'Budget breakdown',
  },
  oldCategoryBreakdownTableLabel: {
    id: `${scope}.oldCategoryBreakdownTableLabel`,
    defaultMessage: 'Category breakdown',
  },
  granularSpendTableLabel: {
    id: `${scope}.granularSpendTableLabel`,
    defaultMessage: 'Granular spend',
  },
  currentBudgetPeriodOptionSuffix: {
    id: `${scope}.currentBudgetPeriodOptionSuffix`,
    defaultMessage: ' (Current)',
  },
  approvedSpend: {
    id: `${scope}.approvedSpend`,
    defaultMessage: 'Approved',
  },
  purchasedSpend: {
    id: `${scope}.purchasedSpend`,
    defaultMessage: 'Purchased',
  },
  billedSpend: {
    id: `${scope}.billedSpend`,
    defaultMessage: 'Billed',
  },
})
